import React, { useState } from 'react';
import { Bell, Check, Loader2 } from 'lucide-react';
import { notifyMe } from '../lib/api';

// variant: 'card' (compact, toggled) | 'pdp' (always-open form)
export const NotifyMe = ({ productId, variant = 'pdp' }) => {
  const [open, setOpen] = useState(variant === 'pdp');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | done | error
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setStatus('loading');
    setError('');
    try {
      await notifyMe(productId, email.trim());
      setStatus('done');
    } catch (err) {
      setError(err.message);
      setStatus('error');
    }
  };

  if (status === 'done') {
    return (
      <div className="flex items-center justify-center gap-2 text-[#a8823c] font-body text-sm" data-testid={`notify-done-${productId}`}>
        <Check size={16} /> You're on the list! We'll email you at launch.
      </div>
    );
  }

  if (variant === 'card' && !open) {
    return (
      <button
        type="button"
        data-testid={`notify-open-${productId}`}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
        className="inline-flex items-center gap-1.5 border border-[#c6a15b]/60 text-[#a8823c] overline text-[0.6rem] px-4 py-2 hover:bg-[#0b0b0b] hover:text-[#e7d3a1] hover:border-[#0b0b0b] transition-colors"
      >
        <Bell size={12} /> Notify Me
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="w-full max-w-sm mx-auto" data-testid={`notify-form-${productId}`}>
      <div className="flex items-stretch gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          placeholder="Your email"
          data-testid={`notify-email-${productId}`}
          className={`field-luxe flex-1 min-w-0 bg-white border px-3 py-2.5 font-body text-sm text-[#1a1a1a] ${status === 'error' ? 'border-red-500 field-shake' : 'border-[#d8cdb8]'}`}
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          data-testid={`notify-submit-${productId}`}
          className="btn-gold px-4 py-2.5 flex items-center gap-1.5 whitespace-nowrap disabled:opacity-60"
        >
          {status === 'loading' ? <Loader2 size={14} className="animate-spin" /> : <Bell size={13} />}
          Notify Me
        </button>
      </div>
      {error && <p className="font-body text-xs text-red-600 mt-1.5">{error}</p>}
    </form>
  );
};

export default NotifyMe;
